import wixData from "wix-data";

let debounceTimer;
export function iTitle_keyPress_1(event,$w) {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
    debounceTimer = undefined;
  }
  debounceTimer = setTimeout (() => {
    filter($w('#iTitle').value);
  }, 200);
}

let lastFilterTitle
function filter(title){
	if (lastFilterTitle !== title) {
		$w('#dataset1').setFilter(wixData.filter().contains('House', title));
		lastFilterTitle = title;
	}
}
